import { defineMessages } from 'react-intl';

export default defineMessages({
  submitOrderString: {
    id: 'submitOrder',
    description: 'submit order',
    defaultMessage: 'Submit Order',
  },
});
